<template>
  <nav class="gfr-menu">
    <slot />
  </nav>
</template>
<style lang="scss">
@import '~/components/gfr/Menu/styles/globe.scss';
</style>
